import { vnTemplate } from "@valnet/vnKnockoutJsTemplates/vnTemplate";
import { LpIcon } from "~/design-system";
import { getSidebarStateClass, store } from "~/state/store";
import { legacyIconNameToPhosphorIconName } from "~/utils/iconName";
const MENU_SIDEBAR_ITEM_TEMPLATE_NAME = "menuSidebar-item-template";
export class menuSidebar_template extends vnTemplate {
    initPartial() {
        this.ensureMenuItemTemplate();
    }
    getTemplateHtml() {
        return /* html */ `
            <div
                class="menu-sidebar-wrapper"
                data-sidebar-collapsible
                data-bind="
                    attr: {
                        'data-state': sidebarStateClass
                    }
                "
            >
                <ul
                    class="menu-sidebar-tree"
                    data-bind="template: { name: '${MENU_SIDEBAR_ITEM_TEMPLATE_NAME}', foreach: menuNodes }"
                ></ul>

                <div class="menu-sidebar-collapse-wrapper">
                    <button
                        type="button"
                        data-bind="click: onToggleSideMenu"
                        class="sidebar-collapse__trigger menu-sidebar__collapse-trigger"
                    >
                        <span class="sidebar-collapse__icon">
                            ${LpIcon({ name: "sidebar", size: 20 })}
                        </span>
                    </button>
                </div>

            </div>
        `;
    }
    getTemplateName() {
        return "menuSidebar-template";
    }
    getMenuItemTemplateHtml() {
        return /* html */ `

            <!-- ko if: hasChildren -->
                <button
                    type="button"
                    class="menu-sidebar-item"
                    data-bind="
                        click: toggle,
                        attr: {
                            'data-level': level,
                            'data-state': isOpen() ? 'open' : 'closed',
                            'aria-controls': submenuId,
                            'aria-expanded': isOpen() ? 'true' : 'false'
                        }
                    "
                >
                    <span class="menu-sidebar-item__content">
                        <!-- ko if: iconName -->
                            <span class="menu-sidebar-item__icon" aria-hidden="true">
                                <i
                                    data-lp-component="Icon"
                                    data-icon-weight="regular"
                                    class="lp-icon ph"
                                    data-bind="css: 'ph-' + iconName"
                                    aria-hidden="true"
                                ></i>
                            </span>
                        <!-- /ko -->
                        <span class="menu-sidebar-item__label" data-bind="text: text"></span>
                    </span>
                </button>

                <ul
                    class="menu-sidebar__children"
                    data-bind="
                        attr: {
                            id: submenuId,
                            hidden: isOpen() ? null : ''
                        },
                        template: { name: '${MENU_SIDEBAR_ITEM_TEMPLATE_NAME}', foreach: children }
                    "
                ></ul>
            <!-- /ko -->

            <!-- ko ifnot: hasChildren -->
                <a
                    class="menu-sidebar-item"
                    data-bind="
                        css: { 'is-active': isSelected },
                        attr: {
                            href: url,
                            'aria-current': isSelected ? 'page' : null
                        }
                    "
                >
                    <span class="menu-sidebar-item__content">
                        <!-- ko if: iconName -->
                            <span class="menu-sidebar-item__icon" aria-hidden="true">
                                <i
                                    data-lp-component="Icon"
                                    data-icon-weight="regular"
                                    class="lp-icon ph"
                                    data-bind="css: 'ph-' + iconName"
                                    aria-hidden="true"
                                ></i>
                            </span>
                        <!-- /ko -->
                        <span class="menu-sidebar-item__label" data-bind="text: text"></span>
                    </span>
                </a>
            <!-- /ko -->

        `;
    }
    buildViewModel() {
        return {
            sidebarStateClass: ko.observable(getSidebarStateClass(store.getState().isSidebarOpen)),
            menuNodes: ko.observableArray([]),
            onToggleSideMenu: () => {
                this.toggleSideMenu();
            },
        };
    }
    setMenus(menus) {
        this.getTemplateViewModel().menuNodes(this.buildSidebarMenuNodes(menus));
    }
    setSidebarState(isOpen) {
        this.getTemplateViewModel().sidebarStateClass(getSidebarStateClass(isOpen));
    }
    toggleSideMenu() {
        store.getState().toggleSidebar();
    }
    ensureMenuItemTemplate() {
        if (document.getElementById(MENU_SIDEBAR_ITEM_TEMPLATE_NAME)) {
            return;
        }
        const template = document.createElement("script");
        template.type = "text/html";
        template.id = MENU_SIDEBAR_ITEM_TEMPLATE_NAME;
        template.innerHTML = this.getMenuItemTemplateHtml();
        document.head.appendChild(template);
    }
    buildSidebarMenuNodes(menus) {
        return menus
            .filter((menu) => menu.visible !== false)
            .map((menu) => this.createSidebarMenuNode(menu, 0));
    }
    createSidebarMenuNode(menu, level) {
        const children = (menu.subMenus ?? [])
            .filter((childMenu) => childMenu.visible !== false)
            .map((childMenu) => this.createSidebarMenuNode(childMenu, level + 1));
        const hasChildren = children.length > 0;
        const isSelected = Boolean(menu.selected);
        const isInSelectedPath = isSelected || children.some((childNode) => childNode.isInSelectedPath);
        let node;
        node = {
            text: menu.text,
            url: menu.url,
            level,
            hasChildren,
            iconName: level === 0 && menu.icon ? legacyIconNameToPhosphorIconName(menu.icon) : "",
            submenuId: hasChildren ? `menu-sidebar-section-${menu.id}` : "",
            children,
            isSelected,
            isInSelectedPath,
            isOpen: ko.observable(hasChildren && isInSelectedPath),
            toggle: () => {
                node.isOpen(!node.isOpen());
            },
        };
        return node;
    }
}
